import { RoleState } from '../../types';

const roleState: RoleState = {
  role: {
    role: null,
  },
};

export default roleState;
